import {
    wsUserByWsId as listWorkspacesByWsIdGraphQL,
    wsUserByUserId as listWorkspacesByUserIdGraphQL,
} from '../../../graphql/queries';
import {queryGqlApi} from "../../../graphql/queryGqlApi";
import { IDataClientService } from '../../../platform/services/data/DataClientService';
import { IAuthService } from '../../../platform/services/auth/AuthService';


export const listWorkspaceUsersByWsId = (
    dataClientService: IDataClientService,
    authService: IAuthService,
    tenantId: string,
    wsId: string, 
    userId?: string, 
    nextToken?: string, 
    limit?: number
): Promise<any> => {
    const condition: any = {};
    const additionalParams: any = {};
    if (userId) {
        condition['eq'] = {
            workspaceId: wsId,
            userId: userId,
        };
    } else {
        condition['beginsWith'] = {
            workspaceId: wsId
        };
    }

    if (nextToken) {
        additionalParams.nextToken = nextToken;
    }
    return queryGqlApi(
        listWorkspacesByWsIdGraphQL,
        {
            ownerId: tenantId,
            workspaceIdUserId: condition,
            limit: limit,
            ...additionalParams
        },
        dataClientService,
        authService,
        'pgServer'
    );
}

export const listWorkspaceUsersByUserId = (
    dataClientService: IDataClientService,
    authService: IAuthService,
    tenantId: string,
    userId: string, 
    nextToken?: string, 
    limit?: number
): Promise<any> => {
    const additionalParams: any = {};

    if (nextToken) {
        additionalParams.nextToken = nextToken;
    }
    return queryGqlApi(
        listWorkspacesByUserIdGraphQL,
        {
            ownerId: tenantId,
            userId: {
                'eq': userId
            },
            limit: limit,
            ...additionalParams
        },
        dataClientService,
        authService,
        'pgServer'
    );
}
